/**
 * Security domain — two-factor authentication (TOTP) query keys and fetchers.
 */
import { apiFetch } from '../../lib/api/client.js';

export const SECURITY_QUERY_KEYS = {
  mfaStatus: ['security', 'mfa-status'] as const,
} as const;

export const mfaStatusKey = SECURITY_QUERY_KEYS.mfaStatus;

export interface MfaStatus {
  enabled: boolean;
}

export interface MfaEnrollment {
  secret: string;
  otpauthUrl: string;
}

export function fetchMfaStatus(): Promise<MfaStatus> {
  return apiFetch<MfaStatus>('/auth/mfa/status');
}

/**
 * Enrolling re-authenticates: acquiring the second factor is at least as
 * sensitive as removing it, and a stolen access token alone must not be able to
 * seize it — once MFA is on with someone else's secret, the real owner cannot
 * log in even after changing their password (AUT-10).
 */
export function enrollMfa(password: string): Promise<MfaEnrollment> {
  return apiFetch<MfaEnrollment>('/auth/mfa/enroll', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ password }),
  });
}

export function verifyMfaEnroll(code: string): Promise<void> {
  return apiFetch<void>('/auth/mfa/enroll/verify', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ code }),
  });
}

export function disableMfa(password: string, code: string): Promise<void> {
  return apiFetch<void>('/auth/mfa/disable', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ password, code }),
  });
}
